var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayCheque(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12582",
    "data-name": "Group 12582",
    transform: "translate(-1471 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148504",
    "data-name": "Rectangle 148504",
    width: 24,
    height: 24,
    transform: "translate(1471 639)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bank-check",
    transform: "translate(1471 524)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 0.462,
    cy: 0.462,
    r: 0.462,
    transform: "translate(23.077 125.944)",
    fill: "#676c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21462",
    "data-name": "Path 21462",
    d: "M23.859,121.141a.468.468,0,0,0-.328-.141H.469a.475.475,0,0,0-.469.469v11.719a.473.473,0,0,0,.469.469H23.531a.473.473,0,0,0,.469-.469v-4.781a.469.469,0,1,0-.938,0v4.313H.938V121.938H23.063v7.25a.469.469,0,1,0,.938,0v-7.719A.468.468,0,0,0,23.859,121.141Z",
    transform: "translate(0)",
    fill: "#676c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21463",
    "data-name": "Path 21463",
    d: "M52.656,226H40.469a.469.469,0,0,0,0,.938H52.656a.469.469,0,0,0,0-.938Z",
    transform: "translate(-38.125 -100.078)",
    fill: "#676c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21464",
    "data-name": "Path 21464",
    d: "M51.25,266H40.469a.469.469,0,1,0,0,.938H51.25a.469.469,0,0,0,0-.937Z",
    transform: "translate(-38.125 -138.203)",
    fill: "#676c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21465",
    "data-name": "Path 21465",
    d: "M40.469,166.938h2.813a.469.469,0,0,0,0-.938H40.469a.469.469,0,0,0,0,.938Z",
    transform: "translate(-38.125 -42.891)",
    fill: "#676c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21466",
    "data-name": "Path 21466",
    d: "M383.4,187.875h1.406a.469.469,0,0,0,0-.938h-.7v-.469a.469.469,0,0,0-.938,0v.489a1.406,1.406,0,0,0,.234,2.793h.469a.469.469,0,0,1,0,.938h-1.406a.469.469,0,0,0,0,.938h.7v.469a.469.469,0,0,0,.938,0v-.489a1.406,1.406,0,0,0-.234-2.793H383.4a.469.469,0,1,1,0-.937Z",
    transform: "translate(-364.092 -61.953)",
    fill: "#676c7b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCheque);
export default __webpack_public_path__ + "static/media/pay_cheque.8d12ede03e92e0fc6046ee3ea2824126.svg";
export { ForwardRef as ReactComponent };